

export default {

    getCreateScheduleById: state => (createScheduleId) => state.getAllCreateSchedule.find(u => u.createScheduleId === createScheduleId),
    
    getCreateScheduleStatusCountOpen : state => () => state.getAllCreateSchedule.find(s => s.isClosed == false),

    getStatusName: state =>(value) => state.status.find(s => s.value === value),
    
    getEmployeeScheduleIdByDateToday: state => (userId, dateToday) => state.getAllCreateSchedule.find(u => u.scheduleDate === dateToday && u.userId === userId)
}